module.exports = __webpack_public_path__ + "img/c16.5061ef7d.png";